<template>
  <div>
    <div class="header py-7 py-lg-8 pt-lg-9" :class="AppStyle.GRADIENT_STYLE">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 0" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <!-- img :src="logo" class="navbar-brand-img" alt="Sidebar logo" width="90%" -->
                <h2>Sign in</h2>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="email address"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="password"
                              v-model="model.password">
                  </base-input>
                  <div class="text-center">
                    <base-button :type="AppStyle.BUTTON_STYLE_S" native-type="submit" class="my-4">Sign in</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppStyle from '@/plugins/appStyle';

export default {
  mixins: [AppStyle.Mixin],
    name: 'Login',
    data() {
      return {
        model: {
          email: '',
          password: ''
        }
      };
    },
    props:{
      logo: {
            type: String,
            default: AppStyle.LOGO,
            description: 'Sidebar app logo'
        },
    },
  computed: {
    ...mapGetters({ currentAccount: 'currentAccount' }),
    ...mapState(
      { 
        account: state => state.account,
      }),
  },
  created () {
    this.checkCurrentLogin()
  },
  updated () {
    this.checkCurrentLogin()
  },
  methods: {
    checkCurrentLogin () {
      if (this.currentAccount) {
        this.$router.replace(this.$route.query.redirect || '/portal')
      }
    },
    onSubmit() {
      this.$api.login(this.model.email, this.model.password).then(request => this.loginSuccessful(request))
        .catch(() => this.loginFailed())
    },
    loginSuccessful (req) {
      if (!req.data.token) {
        this.loginFailed()
        return
      }
      this.error = false
      localStorage.token = req.data.token;
      this.$store.dispatch('login');
      this.$router.replace(this.$route.query.redirect || '/portal');
    },
    loginFailed () {
      this.error = 'Login failed!'
      this.$store.dispatch('logout')
      delete localStorage.token
    },
  },
}
</script>

<style>
  /* Global styles for navbar on login page only */
  .navbar-main > .container {
    display: flex !important;
    flex-direction: column !important;
    align-content: center !important;
    align-items: center !important;
  }
  .navbar-main .navbar-brand {
      margin: 0 !important;
      text-align: center !important;
  }
</style>